import { api } from '../index';

const prefix = '/api/statistics/';

export function apiGetDashboardViewLocationList() {
	return api.get(prefix + 'getDashboardViewLocationList');
}

export function apiGetTotalGrossProfit(unit, from_date, to_date, sales_group_code) {
	return api.get(prefix + 'getTotalGrossProfit', { params: { unit, from_date, to_date, sales_group_code } });
}

export function apiGetAccountReceived(unit, from_date, to_date) {
	return api.get(prefix + 'getAccountReceived', { params: { unit, from_date, to_date } });
}

export function apiGetBestItemList(from_date, to_date, sort_key, start_index, list_size) {
	return api.get(prefix + 'getBestItemList', { params: { from_date, to_date, sort_key, start_index, list_size } });
}

export function apiGetSellerRank(from_date, to_date) {
	return api.get(prefix + 'getSellerRank', { params: { from_date, to_date } });
}

export function apiGetItemClassGroupData(from_date, to_date, sort_key, sales_team) {
	return api.get(prefix + 'getItemClassGroupData', { params: { from_date, to_date, sort_key, sales_team } });
}
